import { styled, Button, Box } from '@mui/material';
import { m } from 'framer-motion';
import { BlockTitle } from 'console/shared/styles/mixins/titles';
export const PanelHeader = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'is_dragging',
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 4,
    margin: '6px 0',
});
export const Title = styled(BlockTitle)({});
export const CustomPanelButton = styled(Button)(({ theme }) => ({
    color: theme.palette.action.active,
    justifyContent: 'flex-start',
    padding: '4px 6px',
}));
export const Panel = styled(m.div)(({ theme }) => ({
    overflow: 'auto',
    backgroundColor: theme.palette.background.default,
}));
